import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';

import {
  ModalBody,
  ModalHeader,
  ModalFooter,
  Align,
  Button,
} from '@sm/wds-react';
import { T, t, FormattedDateTime } from '@sm/intl';
import CancelSeatRequestMutation from './graphql/CancelSeatRequest.graphql';
import RemindSeatRequestMutation from './graphql/RemindSeatRequest.graphql';

import COPY from './SeatRequestCopy';

function PendingModalContent({ onModalFinished, seatRequest, team }) {
  const [cancelSeatRequest, { loading: cancelLoading }] = useMutation(
    CancelSeatRequestMutation,
    {
      onError: () => {
        onModalFinished(t(COPY.TOAST_ERROR));
      },
      onCompleted: () => {
        onModalFinished(t(COPY.TOAST_REQUEST_CANCELED));
      },
    }
  );
  const [remindSeatRequest, { loading: remindLoading }] = useMutation(
    RemindSeatRequestMutation,
    {
      onError: () => {
        onModalFinished(t(COPY.TOAST_ERROR));
      },
      onCompleted: () => {
        onModalFinished(t(COPY.TOAST_REMINDER_SENT));
      },
    }
  );

  const { email, firstName, lastName } = team.accountOwner;
  const emailLabel = firstName
    ? `${firstName}${lastName ? `\u00A0${lastName}` : ''}`
    : email;
  return (
    <>
      <ModalHeader header={<T desc={COPY.MODAL_TITLE_PENDING} />} />
      <ModalBody>
        <p>
          <T
            desc={COPY.PENDING_DESC_1}
            values={{
              date: FormattedDateTime({
                date: new Date(seatRequest.request.date),
              }),
            }}
          />
        </p>
        <p>
          <T desc={COPY.PENDING_DESC_2} />
        </p>
        <p>
          <T
            desc={COPY.PENDING_DESC_3}
            values={{
              email: () => <a href={`mailto:${email}`}>{emailLabel}</a>,
            }}
          />
        </p>
      </ModalBody>
      <ModalFooter>
        <Align placement="left">
          <Button
            variant="ghost"
            color="warning"
            onClick={cancelSeatRequest}
            disabled={remindLoading || cancelLoading}
          >
            <T desc={COPY.CANCEL_REQUEST_BUTTON} />
          </Button>
        </Align>
        <Align placement="right">
          <Button
            onClick={remindSeatRequest}
            color="secondary"
            disabled={remindLoading || cancelLoading}
          >
            <T desc={COPY.SEND_REMINDER_BUTTON} />
          </Button>
          <Button
            onClick={onModalFinished}
            disabled={remindLoading || cancelLoading}
          >
            <T desc={COPY.CLOSE_BUTTON} />
          </Button>
        </Align>
      </ModalFooter>
    </>
  );
}

PendingModalContent.propTypes = {
  onModalFinished: PropTypes.func.isRequired,
  seatRequest: PropTypes.shape({
    request: PropTypes.shape({
      date: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  team: PropTypes.shape({
    accountOwner: PropTypes.shape({
      email: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default PendingModalContent;
